import styled from 'styled-components';

export const IconPersona = styled.img`
  width: 8rem;
  height: 8rem;
`;
